import React from 'react';
import { useAppSelector } from '../../hooks/ReduxHooks';
import { getCurrentClientId, getCurrentUser, isSpecialAccessLogin } from '../../helpers/UserUtility';
import { Button } from 'semantic-ui-react';
import { analyticsTrack } from '../../helpers/AnalyticsUtility';
import { Logout } from '../../auth/AuthService';

export default function SpecialAccessBanner() {
  const companyName = useAppSelector<string>((state) => state.profile.settings.displayName || state.profile.client.name);
  const currentUser = getCurrentUser();
  const showSpecialAccessBanner = isSpecialAccessLogin();

  if (showSpecialAccessBanner) {
    return (
      <div className="special-access-banner">
        <span className="email">Currently logged in as: {currentUser.email}</span>
        <div className="user-info">
          <div className="client-info">
            <span className="client-id">Client ID: {getCurrentClientId()}</span>
            <span className="full-name">Company Name: {companyName}</span>
          </div>
          <Button
            content="End Session"
            className="end-session-button"
            onClick={() => {
              analyticsTrack('Profile Drop-down Button Clicked', { button: 'Logout' });
              Logout();
            }}
          />
        </div>
      </div>
    );
  }

  return null;
}
